import { defineComponent } from 'vue';
import MenuManagement from './MenuManagement.vue';
export default defineComponent({
  name: 'MenuManagementPage',
  components: {
    MenuManagement
  }
});